var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "help" } }, [
    _c("div", { staticClass: "help-warp" }, [
      _c(
        "div",
        { staticClass: "help-warp-tab" },
        [
          _c("nuxt-link", { attrs: { to: "/trait/help" } }, [
            _vm._v("首页 "),
            _c("i", [_vm._v("/")])
          ]),
          _vm.detailInfo.second_id
            ? _c(
                "nuxt-link",
                { attrs: { to: "/trait/help/" + _vm.detailInfo.second_id } },
                [
                  _vm._v(_vm._s(_vm.detailInfo.second_name) + " "),
                  _c("i", { staticClass: "el-icon-arrow-right" })
                ]
              )
            : _vm._e(),
          _vm.detailInfo.third_id
            ? _c(
                "nuxt-link",
                {
                  attrs: {
                    to: {
                      path: "/trait/help/" + _vm.detailInfo.second_id,
                      query: { id: _vm.detailInfo.third_id }
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm.detailInfo.third_name) + " "),
                  _c("i", { staticClass: "el-icon-arrow-right" })
                ]
              )
            : _vm._e(),
          _c("span", [_vm._v("正文")])
        ],
        1
      ),
      _c("div", { staticClass: "help-type-detail" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.detailInfo.problem_title))
        ]),
        _c("p", { staticClass: "time" }, [
          _vm._v(
            _vm._s(_vm.detailInfo.update_time || _vm.detailInfo.create_time)
          )
        ]),
        _c("div", {
          staticClass: "article",
          domProps: { innerHTML: _vm._s(_vm.detailInfo.problem_content) }
        })
      ])
    ]),
    _vm.showMask
      ? _c("div", { staticClass: "mask", on: { click: _vm.hideMsk } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46b66d40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46b66d40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/trait/help/detail/_id.vue
// module id = 4MBg
// module chunks = 6